// extracting index from 'array[index]'
export const extractIndex = (source) => parseInt(source.split(/[[\]]/g)[1], 10)
